import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RelNotesComponent } from './rel-notes/rel-notes.component';
import { HomeComponent } from './home/home.component';
import { TacSupportComponent } from './tac-support/tac-support.component';
import { NewrequestComponent } from './newrequest/newrequest.component';
import { FingerprintidComponent } from './fingerprintid/fingerprintid.component';
import { CustomDetectorComponent } from './custom-detector/custom-detector.component';
import { SidenavHeaderComponent } from './sidenav-header/sidenav-header.component';
import { CustomeDetectorUpdateComponent } from './custome-detector-update/custome-detector-update.component';


const routes: Routes = [
  { path: 'home/showAllTags', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  { path: 'relnotes', component: RelNotesComponent },
  { path: 'tacsupport', component: TacSupportComponent },
  { path: 'newrequest', component: NewrequestComponent },
  {path : 'eve',component : FingerprintidComponent},
  {path : 'customdetector',component : CustomDetectorComponent},
  {path : 'customdetectorupdate',component : CustomeDetectorUpdateComponent},
  {path : 'nav',component : SidenavHeaderComponent},
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  // { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
